import { useAuth } from '../contexts/AuthContext';

/**
 * Shared rules for disabling top navigation during critical onboarding
 * (email verification, or incomplete UniversalSignup: patients through medical + dosha;
 * healthcare providers through basic profile only).
 */
export function useOnboardingNavLock() {
  const { user, isAuthenticated } = useAuth();

  const rawV = user?.verification_email as unknown;
  const emailVerified = rawV === true || rawV === 1 || rawV === 'true';
  const profileLevel = user?.profile_completion_level ?? 0;

  const isDoctorOnboardingLocked =
    !!user && user.role === 'doctor' && emailVerified && profileLevel < 3;

  const isUserOnboardingLocked =
    !!user &&
    user.role !== 'admin' &&
    user.role !== 'doctor' &&
    emailVerified &&
    profileLevel < 5;

  const isEmailVerificationLocked =
    !!user && user.role !== 'admin' && !emailVerified;

  const isNavLocked =
    isAuthenticated &&
    !!user &&
    (isDoctorOnboardingLocked ||
      isUserOnboardingLocked ||
      isEmailVerificationLocked);

  const needsProfileProgressMessage =
    isDoctorOnboardingLocked || isUserOnboardingLocked;

  const lockTitle = needsProfileProgressMessage
    ? 'Complete your profile to continue.'
    : isEmailVerificationLocked
      ? 'Verify your email to continue.'
      : undefined;

  return {
    isNavLocked,
    lockTitle,
    isDoctorBasicProfileLocked: isDoctorOnboardingLocked,
    isUserBasicProfileLocked: isUserOnboardingLocked,
    isEmailVerificationLocked,
    needsBasicProfileCompletion: needsProfileProgressMessage,
  };
}
